import React from "react";
import { Box, Typography, Link, useTheme, Paper, Stack } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";

const About: React.FC = () => {
    const theme = useTheme();
    return (
        <Box sx={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                <InfoOutlinedIcon color="primary" />
                <Typography sx={{ color: theme.palette.text.primary }} variant="h5">
                    About Event Manager
                </Typography>
            </Stack>
            <Typography sx={{ color: theme.palette.text.secondary, mb: 3 }} variant="body1">
                Quick access to help, support, and key app information.
            </Typography>

            <Paper
                variant="outlined"
                sx={{
                    p: 2,
                    mb: 2,
                    borderColor: "primary.light",
                    backgroundColor:
                        theme.palette.mode === "dark" ? "rgba(25,118,210,0.08)" : "rgba(25,118,210,0.04)",
                }}
            >
                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                    <HelpOutlineIcon color="primary" />
                    <Typography sx={{ color: theme.palette.text.primary }} variant="h6">
                        Need help?
                    </Typography>
                </Stack>
                <Typography sx={{ color: theme.palette.text.secondary, mb: 1 }} variant="body2">
                    Open the user guide for step-by-step instructions and common workflows.
                </Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                    <MenuBookOutlinedIcon fontSize="small" color="primary" />
                    <Link
                        href="https://dev.azure.com/EK-AUTOMATION/Event%20Manager/_wiki/wikis/Event-Manager.wiki/7346/User-guide"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        User guide
                    </Link>
                </Stack>
            </Paper>

            <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                <Typography sx={{ color: theme.palette.text.primary }} variant="h6" gutterBottom>
                    What this app does
                </Typography>
                <Typography sx={{ color: theme.palette.text.primary }} variant="body2">
                    The Event Manager supports AGV event lifecycle management: import, review, edit, approval,
                    and export of event data for operations and engineering workflows.
                </Typography>
            </Paper>

            <Paper variant="outlined" sx={{ p: 2 }}>
                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                    <MailOutlineIcon color="primary" />
                    <Typography sx={{ color: theme.palette.text.primary }} variant="h6">
                        Contact support
                    </Typography>
                </Stack>
                <Typography sx={{ color: theme.palette.text.secondary, mb: 1 }} variant="body2">
                    For administrative support or access questions, contact:
                </Typography>
                <Typography sx={{ color: theme.palette.text.primary }} variant="body1">
                    <Link href={"mailto:event-manager@ek-robotics.com?subject=Support%20Request&body=Hello%20Admin%20Team,"}>
                        event-manager@ek-robotics.com
                    </Link>
                </Typography>
            </Paper>

            <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                    <BugReportOutlinedIcon color="primary" />
                    <Typography sx={{ color: theme.palette.text.primary }} variant="h6">
                        Report a bug
                    </Typography>
                </Stack>
                <Typography sx={{ color: theme.palette.text.secondary, mb: 1 }} variant="body2">
                    Found an issue? Please report it so the team can investigate and fix it.
                </Typography>
                <Typography sx={{ color: theme.palette.text.primary }} variant="body1">
                    <Link
                        href="https://dev.azure.com/EK-AUTOMATION/Event%20Manager/_boards/board/t/Event%20Manager%20Team/Stories"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Open bug report form
                    </Link>
                </Typography>
            </Paper>
        </Box>
    );
};

export default About;